<template>
  <div
    v-if="datas"
    class="loadSUccessBtn"
    @click="onClick"
    :class="[datas.btnType, datas.disabled ? 'disabled' : '']"
  >
    <transition name="v-btn-label" mode="out-in">
      <div v-if="datas.loading">
        <span class="spinner"></span>
      </div>
      <span
        v-else-if="datas.success"
        class="loadAfter_success_icon el-icon el-icon-check"
      ></span>
      <span
        v-else-if="datas.error"
        class="loadAfter_error_icon el-icon el-icon-close"
      ></span>
      <span v-else class="btnTextArea">
        <span class="btnText">
          <slot></slot>
        </span>
        <template v-if="datas.isShowTextIcon">
          <span
            v-if="datas.isShowTextIcon === 1"
            class="success_icon el-icon el-icon-success"
          ></span>
          <span
            v-if="datas.isShowTextIcon === 2"
            class="error_icon el-icon el-icon-error"
          ></span>
        </template>
      </span>
    </transition>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'LOAD_SUCCESS_BTN',
  mixins: [cup_base_data_mixin],
  props: {
    datas: {
      type: Object,
      default: () => ({
        btnType: 'start', //开始状态：start || 动画中：playing
        loading: false,
        disabled: false,
        success: false,
        error: false,
        isShowTextIcon: 0, //0：不展示图标， 1：展示成功图标；2：展示失败图标
      }),
    },
    // isIcon: {
    //   type: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner {
  display: inline-block;
  border-radius: 50%;
  width: 1.11vw;
  height: 1.11vw;
  border: 0.166vw solid transparent;
  vertical-align: middle;
  font-size: 1.11vw;
  border-top-color: var(--mixtmt_whiteColor);
  animation: spin 1s cubic-bezier(0.55, 0.15, 0.45, 0.85) infinite;
}
.loadAfter_success_icon,
.loadAfter_error_icon {
  font-size: 1.38vw;
  font-weight: bold;
}
.btnTextArea {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  .btnText {
    font-size: 0.972vw;
    font-weight: normal;
  }
  .success_icon,
  .error_icon {
    padding-left: 0.416vw;
    font-size: 0.972vw;
    font-weight: bold;
  }
}

.loadSUccessBtn {
  width: 5.55vw;
  height: 2.083vw;
  /* height: 1.736vw; */
  /* padding: 0 0.833vw; */
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 1.389vw;
  font-weight: 500;
  font-size: 0.972vw;
  /* box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2),
    0 4px 6px -2px rgba(0, 0, 0, 0.05); */
  transition: background-color 120ms;
  overflow: hidden;

  &.playing,
  &.start:hover:not(.disabled) {
    color: var(--mixtmt_whiteColor);
    background-color: var(--mixtmt_mainColor8);
    .btnTextArea {
      .success_icon {
        color: var(--mixtmt_whiteColor);
      }
      .error_icon {
        color: var(--mixtmt_whiteColor);
      }
    }
  }
  &.playing:hover {
    cursor: default;
  }

  &.start {
    color: var(--mixtmt_greyColor2);
    background-color: var(--mixtmt_whiteColor);
    border: 1px solid var(--mixtmt_greyColor7);
    &:hover {
      cursor: pointer;
    }
    .btnTextArea {
      .success_icon {
        color: var(--mixtmt_mainColor8);
      }
      .error_icon {
        color: var(--mixtmt_errColor);
      }
    }
  }
  &.disabled {
    cursor: default;
    .btnTextArea {
      color: var(--mixtmt_greyColor0);
      .success_icon,
      .error_icon {
        color: var(--mixtmt_greyColor0);
      }
    }
  }
}

.v-btn-label-enter-active {
  animation: slide-in-down 260ms cubic-bezier(0, 0, 0.2, 1);
}

.v-btn-label-leave-active {
  animation: slide-out-down 260ms cubic-bezier(0.4, 0, 1, 1);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@keyframes slide-in-down {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }

  50% {
    opacity: 0.8;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  40% {
    opacity: 0.2;
  }

  100% {
    transform: translateY(20px);
    opacity: 0;
  }
}
</style>
